import { render, staticRenderFns } from "./AddResource.vue?vue&type=template&id=706bae21&scoped=true"
import script from "./AddResource.vue?vue&type=script&lang=js"
export * from "./AddResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706bae21",
  null
  
)

export default component.exports